module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-move-clockwise-9f029fdddc01f049cfc8e00882f5fc76.png";